import { render, staticRenderFns } from "./InformationTableChild.vue?vue&type=template&id=e245c3d4&scoped=true&"
import script from "./InformationTableChild.vue?vue&type=script&lang=js&"
export * from "./InformationTableChild.vue?vue&type=script&lang=js&"
import style0 from "./InformationTableChild.vue?vue&type=style&index=0&id=e245c3d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e245c3d4",
  null
  
)

export default component.exports